/* Pinnacle Garage USA - vehicle results ("N products fit your <car>") on collection pages, grouped as
   Wheels / Exterior / Interior / Suspension / More instead of Wheels / Bumpers & Body Kits / Other Parts.
   The results are built by sections/pg-shop-filters.liquid; this regroups its cards (same order inside each group)
   using each product's type, read from the /products.json responses the sidebar loads. 24 cards per group are
   shown, with a "Show all" button for the rest.
   Wheels group order: wheels made for the vehicle's make and universal (aftermarket) wheels first, ordered by
   performance (window.PG_WSCORE, assets/pg-wheel-scores.js) - a universal wheel only goes ahead of a brand wheel when
   it sells / converts better, on a tie the brand wheel wins; wheels made for another make that still fit go last.
   Also on brand pages: the title bar under the banner says "All Products" while the banner is in view and switches
   back to the collection title once the banner has scrolled away,
   and "Show all products" in the results goes to the collection page of the vehicle's make. */
(function () {
  var TYPE = window.PG_PTYPE = window.PG_PTYPE || {}, TITLE = {}, SHOW = 24;
  var RJ = Response.prototype.json;
  if (!RJ._pgGrp) {
    Response.prototype.json = function () {
      var u = this.url || '', pr = RJ.apply(this, arguments);
      return /products\.json/.test(u) ? pr.then(function (d) {
        try { (d && d.products || []).forEach(function (p) { TYPE[p.handle] = p.product_type || ''; TITLE[p.handle] = p.title || ''; }); } catch (e) {}
        return d;
      }) : pr;
    };
    Response.prototype.json._pgGrp = 1;
  }
  var G = [['wheels', 'Wheels'], ['exterior', 'Exterior'], ['interior', 'Interior'], ['suspension', 'Suspension'], ['more', 'More']];
  function group(ty) {
    var t = String(ty || '').toUpperCase().trim();
    if (/STEERING|SEAT|INTERIOR/.test(t)) return 'interior';
    if (/^WHEELS?$/.test(t)) return 'wheels';
    if (/BUMPER|BODY KIT|LIP|SPLITTER|SKIRT|DIFFUSER|SPOILER|WING|GRIL|HOOD|FENDER|EMBLEM|MIRROR|EXTERIOR|LIGHT/.test(t)) return 'exterior';
    if (/COILOVER|SPRING|ARM|ROD|CAMBER|BUSHING|SWAY|STRUT|SUBFRAME|TRACTION|LATERAL|SUSPENSION/.test(t)) return 'suspension';
    return 'more';
  }
  function veh() { try { var v = JSON.parse(localStorage.getItem('pgVehicle') || 'null'); return v && v.mk ? v : null; } catch (e) { return null; } }
  function has(t, w) { return new RegExp('(^|[^A-Z])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^A-Z]|$)').test(t); }
  /* 0 = made for this make, 1 = universal, 2 = made for another make */
  function owner(title, mk) {
    if (!mk) return 1;
    var M = window.PG_MAKES || {}, O = window.PG_OWN_WHEEL_WORDS || {}, t = String(title || '').toUpperCase();
    if ((M[mk] || [mk.toUpperCase()]).concat(O[mk] || []).some(function (w) { return has(t, w); })) return 0;
    for (var k in M) if (k !== mk && M[k].some(function (w) { return has(t, w); })) return 2;
    return 1;
  }
  function sortWheels(list) {
    var v = veh(), mk = v && v.mk, S = window.PG_WSCORE || {};
    var rows = list.map(function (a, i) {
      var h = handleOf(a);
      return { a: a, i: i, o: owner(TITLE[h] || (a.querySelector('.pg-sf-pc__name') || {}).textContent, mk), s: S[h] || 0, l: a.querySelector('.pg-sf-pc__badge--1') ? 1 : 2 };
    });
    rows.sort(function (x, y) { return ((x.o === 2) - (y.o === 2)) || (y.s - x.s) || (x.o - y.o) || (y.l - x.l) || (x.i - y.i); });
    return rows.map(function (r) { return r.a; });
  }
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function regroup(res) {
    var old = res.querySelectorAll(':scope > .pg-sf-grp');
    if (!old.length || res.querySelector(':scope > .pg-sf-grp[data-pg-grp]')) return;
    var cards = [].slice.call(res.querySelectorAll(':scope > .pg-sf-grp a.pg-sf-pc'));
    if (!cards.length) return;
    if (cards.some(function (a) { return !(handleOf(a) in TYPE); })) return; /* types not known yet */
    var by = {}; G.forEach(function (g) { by[g[0]] = []; });
    cards.forEach(function (a) { by[group(TYPE[handleOf(a)])].push(a); });
    by.wheels = sortWheels(by.wheels);
    var used = G.filter(function (g) { return by[g[0]].length; });
    var nav = res.querySelector(':scope > .pg-sf-jump');
    if (nav) nav.remove();
    var frag = document.createDocumentFragment();
    if (used.length > 1) {
      nav = document.createElement('nav'); nav.className = 'pg-sf-jump'; nav.setAttribute('aria-label', 'Jump to');
      nav.innerHTML = used.map(function (g) { return '<a href="#pg-sf-grp-' + g[0] + '">' + esc(g[1]) + ' <span>' + by[g[0]].length + '</span></a>'; }).join('');
      frag.appendChild(nav);
    }
    used.forEach(function (g) {
      var list = by[g[0]], sec = document.createElement('section');
      sec.className = 'pg-sf-grp'; sec.id = 'pg-sf-grp-' + g[0]; sec.setAttribute('data-pg-grp', g[0]);
      sec.innerHTML = '<div class="pg-sf-grp__h"><h3>' + esc(g[1]) + '</h3><span>' + list.length + ' product' + (list.length === 1 ? '' : 's') + '</span></div><div class="pg-sf-res__grid"></div>';
      var grid = sec.lastChild;
      list.forEach(function (a, i) { if (i < SHOW) a.removeAttribute('hidden'); else a.setAttribute('hidden', ''); grid.appendChild(a); });
      if (list.length > SHOW) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'button button--secondary pg-sf-res__more'; b.setAttribute('data-pg-more', g[0]);
        b.textContent = 'Show all ' + list.length + ' ' + g[1].toLowerCase(); sec.appendChild(b);
      }
      frag.appendChild(sec);
    });
    old.forEach(function (s) { s.remove(); });
    res.appendChild(frag);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pg-more]'); if (!b) return;
    var sec = b.closest('.pg-sf-grp'); if (sec) sec.querySelectorAll('a.pg-sf-pc[hidden]').forEach(function (a) { a.removeAttribute('hidden'); });
    b.remove();
  });
  /* "Show all products": open the full collection of the vehicle's make (?all=1, see below) */
  var KNOWN = 'acura,alfa-romeo,aston-martin,audi,bmw,buick,cadillac,chevrolet,chevrolet-gmc,chrysler,dodge,fiat,ford,gmc,honda,honda-acura,hyundai,infiniti,jaguar,jeep,kia,land-rover,lexus,lincoln,maserati,mazda,mercedes-benz,mini-cooper,mitsubishi,nissan,nissan-infiniti,porsche,subaru,suzuki,tesla,toyota,toyota-scion,volkswagen,volvo'.split(',');
  var ALIAS = { mini: 'mini-cooper', scion: 'toyota-scion', ram: 'dodge', genesis: 'hyundai' };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pg-sf-res [data-sf="exit"]'); if (!b) return;
    var v = veh(); if (!v) return;
    var h = String(v.mk).toLowerCase().replace(/\s+/g, '-'); h = ALIAS[h] || h;
    if (KNOWN.indexOf(h) < 0) return;
    e.preventDefault(); e.stopPropagation(); location.href = '/collections/' + h + '?all=1';
  }, true);
  /* arriving from "Show all products" (?all=1): the brand page normally opens the saved vehicle's fitting parts
     straight away - show the whole collection instead until the shopper picks a vehicle again */
  if (/[?&]all=1/.test(location.search)) {
    var acted = false, fn = window.PG_SF_APPLY, de = document.documentElement;
    /* the brand box's "Showing parts that fit your ..." line is hidden too, since all products are showing */
    de.classList.add('pg-all');
    var st = document.createElement('style'); st.textContent = 'html.pg-all .pgbp-fitbar { display: none !important; }'; (document.head || de).appendChild(st);
    /* only the shopper using a vehicle finder (a dropdown or its button) counts - not closing the popup etc. */
    document.addEventListener('change', function (e) { if (e.isTrusted && e.target && e.target.tagName === 'SELECT') acted = true; }, true);
    document.addEventListener('click', function (e) { if (e.isTrusted && e.target.closest && e.target.closest('.pgbp-finder button, .pg-sf__card--veh button, .pg-sf__veh button')) acted = true; }, true);
    ['change', 'click'].forEach(function (ev) { document.addEventListener(ev, function () { if (acted) de.classList.remove('pg-all'); }); });
    function wrap(f) { return typeof f !== 'function' ? f : function () { return acted ? f.apply(this, arguments) : false; }; }
    try { Object.defineProperty(window, 'PG_SF_APPLY', { configurable: true, get: function () { return fn; }, set: function (f) { fn = wrap(f); } }); fn = wrap(fn); } catch (er) {}
  }
  /* brand pages: the title bar under the banner reads "All Products" while the banner (which already shows the
     brand) is in view; once the banner's title has scrolled up under the header, the bar switches back to the
     collection title (e.g. "Acura"), and back again on the way up - a quick fade, the bar itself never moves.
     Vehicle results ("Parts for your ...") are left alone. */
  var ALL = 'All Products', colName = '', want = null, fading = false;
  function bar() { return document.querySelector('.pgx-headbar h2'); }
  function isOurs(txt) { var u = String(txt || '').trim().toUpperCase(); return u === ALL.toUpperCase() || (colName && u === colName.toUpperCase()); }
  function heroGone() {
    var h1 = document.querySelector('.pgbp-hero h1'); if (!h1) return false;
    var hd = document.querySelector('sticky-header, .header-wrapper, .section-header');
    var top = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
    return h1.getBoundingClientRect().bottom < top + 4;
  }
  function setTitle(h2, txt) {
    if (h2.textContent.trim() === txt) return;
    if (h2.dataset.pgReady !== '1') { h2.textContent = txt; return; }
    if (fading) return;
    fading = true; h2.classList.add('pgx-ht-out');
    setTimeout(function () {
      var cur = bar();
      if (cur && isOurs(cur.textContent)) cur.textContent = want;
      if (cur) cur.classList.remove('pgx-ht-out');
      fading = false;
      if (cur && want && cur.textContent.trim() !== want) setTitle(cur, want);
    }, 170);
  }
  function headTitle() {
    if (!document.querySelector('.pgbp-hero')) return;
    var h2 = bar(), root = document.querySelector('.pg-sf[data-title]');
    if (!h2) return;
    if (!colName) colName = String(root && root.getAttribute('data-title') || (document.querySelector('.pgbp-hero h1') || {}).textContent || '').trim();
    if (!colName) return;
    if (h2.dataset.orig && isOurs(h2.dataset.orig)) h2.dataset.orig = ALL;
    if (!isOurs(h2.textContent)) return;
    want = heroGone() ? colName : ALL;
    setTitle(h2, want);
    h2.dataset.pgReady = '1';
  }
  if (!document.getElementById('pgx-ht-css')) {
    var hs = document.createElement('style'); hs.id = 'pgx-ht-css';
    hs.textContent = '.pgx-headbar h2 { transition: opacity .17s ease, transform .17s ease; } .pgx-headbar h2.pgx-ht-out { opacity: 0; transform: translateY(-3px); }';
    (document.head || document.documentElement).appendChild(hs);
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; headTitle(); }); }, { passive: true });
  var t = null;
  function scan() { headTitle(); document.querySelectorAll('.pg-sf-res').forEach(regroup); }
  function start() { scan(); new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 30); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();